import * as React from 'react';

import { translate } from '~l10n/client';

import { ExportFeedback } from './ExportFeedback';
import { Email } from './ExportFeedbackIcons';

interface Props {
  onBack: () => void;
}

const ExportFeedbackEmailStudentComplete = ({ onBack }: Props) => (
  <ExportFeedback
    onBack={onBack}
    icon={<Email />}
    title={translate('Sending Results')}
    message={translate(
      'Your students should receive their results in the next few minutes.'
    )}
  />
);

export { ExportFeedbackEmailStudentComplete };
